/**
 * Devices Preview in Manufacturer, only minimal information to keep it lightweight
 */
export class DbLocManufacturerDevicePreview {
  id: number | undefined;
  name: string = "";
  logo: string = "";

  manufacturer: string = "";
  completeManufacturersList: string[] = [];

  frDeviceType: string = "";
  spDeviceType: string = "";
  enDeviceType: string = "";

}

/**
 * Model for Manufacturers
 */
export class DbLocManufacturer {
  id: number | undefined;
  name: string = "";
  logo: string = "";
  devices: DbLocManufacturerDevicePreview[] = [];
}
